import React, { Component } from 'react';
import { Form, Modal, Select, message, Input, Button } from 'antd';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';

const { Option } = Select;
const api = services.api;
/**
 * 修改快递单号
 */
class Modifydelivery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };
    }

    showModal = () => {
        console.log(this.props.rows);
        this.setState({
            visible: true,
        });
        this.props.form.setFields({
            saleNumStatus: {
                value: this.props.rows.saleNumStatus,
            },
            maxSaleNum: {
                value: this.props.rows.maxSaleNum,
            },
        });
    };

    handleOk = (e) => {
        console.log(this.props.entity);
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            console.log(values.saleNumStatus);
            if (!err) {
                console.log(this.props);
                let value;
                value = {
                    sale_num_status: values.saleNumStatus,
                };
                api.put(value, {
                    apiPath: `/shippingOrderNew/update_express_number/${this.props.rows.sendOrderNo}?express_number=${values.saleNumStatus}`,
                }) // shippingOrder/update_express_number/${this.props.rows.id}?express_number=values.saleNumStatus
                    .then(() => {
                        message.success('修改成功');
                    })
                    .catch(errorHandle);
                this.setState({
                    visible: false,
                });
                let params = {
                    type: 'FK_POINTS',
                };
                // 列表数据刷新
                this.props.entity.search({
                    ...params,
                    ...this.props.entity.filters,
                });
            } else {
                message.error('请填写完整表单再提交');
            }
        });
    };

    handleCancel = (e) => {
        this.props.form.resetFields();
        this.setState({
            visible: false,
        });
    };

    render() {
        const {
            rows: { deliveryStatus },
        } = this.props;
        const { visible, inputVisible } = this.state;
        return (
            <div>
                {deliveryStatus == 2 && (
                    <Button type="link" target="_blank" onClick={this.showModal}>
                        修改快递单号
                    </Button>
                )}

                <Modal
                    visible={visible}
                    title={
                        <div>
                            修改快递单号
                            <span
                                style={{
                                    fontSize: '12px',
                                    color: '#fac26f',
                                    display: 'inline-block',
                                    marginLeft: '12px',
                                }}
                            >
                                *仅支持修改电商仓商品的发货物流单号
                            </span>
                        </div>
                    }
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    <Form labelCol={{ span: 5 }} wrapperCol={{ span: 14 }} layout="horizontal">
                        <Form.Item label="原快递单号:">{this.props?.rows?.expressNumber}</Form.Item>
                    </Form>
                    <Form
                        style={{ marginTop: '-20px' }}
                        labelCol={{ span: 5 }}
                        wrapperCol={{ span: 14 }}
                        layout="horizontal"
                    >
                        <Form.Item label="修改为:">
                            {this.props.form.getFieldDecorator('saleNumStatus', {
                                rules: [
                                    { required: true, message: '修改后的快递单号不能为空' },
                                    {
                                        pattern: /^[A-Za-z0-9]+$/,
                                        message: '名称仅支持数字、字母输入',
                                    },
                                ],
                            })(<Input placeholder="请输入要修改的快递单号" />)}
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default Form.create()(Modifydelivery);
